
import React from "react";
import { NotificationProductData } from "@/types/notifications";
import ProductFieldsForm from "./ProductFieldsForm";
import { Search } from "lucide-react";

interface ProductFieldsSectionProps {
  showProductFields: boolean;
  products: NotificationProductData[];
  onProductsChange: (products: NotificationProductData[]) => void;
}

const ProductFieldsSection = ({ 
  showProductFields, 
  products, 
  onProductsChange 
}: ProductFieldsSectionProps) => {
  if (!showProductFields) return null;

  return (
    <div className="space-y-4 mt-4 p-4 bg-blue-50 rounded-md border border-blue-100">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <h3 className="font-medium text-blue-700">Productinformatie</h3>
        <div className="flex items-center mt-1 sm:mt-0 text-xs text-blue-600">
          <Search className="h-3 w-3 mr-1" /> 
          <p>Zoek op artikelnummer om productnaam, eenheid en BC automatisch in te vullen</p>
        </div>
      </div>
      
      <ProductFieldsForm 
        products={products.length ? products : [createEmptyProduct()]} 
        onProductsChange={onProductsChange} 
      />
    </div>
  );
};

// Helper to create an empty product
function createEmptyProduct(): NotificationProductData {
  return {
    product_name: '',
    product_eenheid: '',
    product_sku: '',
    product_bc: '',
    product_quantity: 1,
    product_color: ''
  };
}

export default ProductFieldsSection;
